import { Dayjs } from 'dayjs';
import { dateTimeFormat } from 'global.constants';

/**
 * SetupDateForRequest
 *
 * @description On change handler for the date field
 * @param Dayjs | null value Selected date values
 * @returns Date data
 */
export const setupDateForRequest = (value: Dayjs | null): string | null => {
  return value ? value.format(dateTimeFormat) : null;
};

/**
 * HandleRemoveSelectedSearchFilterTag
 *
 * @description
 * @param {string}                                                                    fieldName     Selected field name to update
 * @param {string}                                                                    selectedValue The vaslue which needs to be removed
 * @param {Array<string>}                                                             existingList  Currently selected list
 * @param {(field: string, value: any, shouldValidate?: boolean | undefined) => void} setFieldValue Helper method to update the formik values
 * @returns {void}
 */
export const handleRemoveSelectedSearchFilterTag = (
  fieldName: string,
  selectedValue: string,
  existingList: Array<string>,
  setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void,
  onChangeHandler: (key: string, value: Array<string>) => void
): void => {
  const updatedList = existingList.filter(currentlySelectedValue => currentlySelectedValue !== selectedValue);

  setFieldValue(fieldName, updatedList);
  onChangeHandler(fieldName, updatedList);
};